module.exports = __webpack_public_path__ + "img/04_C_T.05cfdab0.png";